import gql from "graphql-tag";

export const GET_PROJECT = gql`
    query Project($projectId: ID!){
        project(projectId: $projectId) {
            projectId
            userId
            shareCategoryType
            shareCategoryId
            projectName
            projectDescription
            projectStatus
            projectPriority
            startAt
            endAt
            createdAt
            updatedAt
            deleted
            deletedAt
            team {
                teamId
                teamName
            }
            integration {
                integrationId
                integrationName
            }
        }
    }
`;

export const GET_PROJECTS = gql`
    query Projects($searchStr: String, $limit: Int, $offset: Int, $showDeleted: Boolean, $orderList: [String]){
        projects(searchStr: $searchStr, limit: $limit, offset: $offset, showDeleted: $showDeleted, orderList: $orderList) {
            projectId
            userId
            shareCategoryType
            shareCategoryId
            projectName
            projectDescription
            projectStatus
            projectPriority
            startAt
            endAt
            createdAt
            updatedAt
            deleted
            deletedAt
            team {
                teamId
                teamName
            }
            integration {
                integrationId
                integrationName
            }
        }
    }
`;

export const GET_PROJECTS_OF_SHARE = gql`
    query ProjectsOfShare($shareCategoryType: String!, $shareCategoryId: ID!, $searchStr: String, $limit: Int, $offset: Int, $showDeleted: Boolean, $orderList: [String]){
        projectsOfShare(shareCategoryType: $shareCategoryType, shareCategoryId: $shareCategoryId, searchStr: $searchStr, limit: $limit, offset: $offset, showDeleted: $showDeleted, orderList: $orderList) {
            projectId
            userId
            shareCategoryType
            shareCategoryId
            projectName
            projectDescription
            projectStatus
            projectPriority
            startAt
            endAt
            createdAt
            updatedAt
            deleted
            deletedAt
            team {
                teamId
                teamName
            }
            integration {
                integrationId
                integrationName
            }
        }
    }
`;

export const GET_PROJECTS_BY_NAME = gql`
    query ProjectsByName($searchStr: String, $limit: Int, $offset: Int, $orderList: [String]){
        projectsByName(searchStr: $searchStr, limit: $limit, offset: $offset, orderList: $orderList) {
            projectId
            projectName
        }
    }
`;

export const CREATE_PROJECT = gql`
    mutation CreateProject($newProject: newProject!) {
        createProject(
            newProject: $newProject
        ) {
            returnCode
            message
            id
            name
        }
    }
`;

export const UPDATE_PROJECT = gql`
    mutation UpdateProject($changedProject: changedProject!) {
        updateProject(
            changedProject: $changedProject
        ) {
            returnCode
            message
        }
    }
`;

export const DELETE_PROJECT = gql`
    mutation DeleteProject($deleteProjectId: ID!) {
        deleteProject(
            deleteProjectId: $deleteProjectId
        ) {
            returnCode
            message
        }
    }
`;

